<template>
  <div class="box">
    <div class="box_header">
      <div class="rounded-container">
        <el-input
          placeholder="请输入学院名称"
          v-model="formData.searchValue"
          class="rounded-input"
          @input="searchViewList"
        ></el-input>
      </div>
    </div>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <component
          :is="componentType"
          :list="list"
        />
      </van-list>
    </div>
    <div class="bottom_box">
      <el-button class="yuyue__tomy" round @click="goToMyReservation">我的预约</el-button>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
import { Toast } from "vant";
import ApplyRoomList from "./components/ApplyRoomList.vue";
import CollegeItemList from "./components/CollegeItemList.vue";

export default {
  components: { ApplyRoomList, CollegeItemList },
  data() {
    return {
      labOpenRemark: "",
      formData: {
        searchValue: "", // 搜索框的绑定值
      },
      pic: [
        {
          src: require("../../assets/colleageImg/国防科技大学第六十三研究院.png"),
          alt: "第六十三研究院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学电子对抗学院.png"),
          alt: "电子对抗学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学电子科学学院.png"),
          alt: "电子科学学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学计算机学院.png"),
          alt: "计算机学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学军政基础教育学院.png"),
          alt: "军政基础教育学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学空天科学学院.png"),
          alt: "空天科学学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学理学院.png"),
          alt: "理学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学气象海洋学院.png"),
          alt: "气象海洋学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学前沿交叉学院.png"),
          alt: "前沿交叉学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学实试验训练基地.png"),
          alt: "实试验训练基地",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学外国语学院.png"),
          alt: "外国语学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学系统工程学院.png"),
          alt: "系统工程学院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学研究生院.png"),
          alt: "研究生院",
        },
        {
          src: require("../../assets/colleageImg/国防科技大学智能科学学院.png"),
          alt: "智能科学学院",
        },
      ],
      show: false,
      orgName: "",
      labName: "",
      loading: false,
      finished: false,
      total: 0,
      page: 1, // 当前页码
      pageSize: 12, // 每页加载的数据量
      list: [], // 学院列表
    };
  },
  methods: {
    goToMyReservation() {
      this.$router.push("/myApply");
    },
    async searchViewList() {
      try {
        this.page = 1; // 确保从第一页开始
        await this.getLabList();
      } catch (error) {
        this.finished = true;
        this.loading = false;
      }
    },
    async onLoad() {
      if (this.finished || !this.list.length) return;
      // 更新页码
      this.page++;
      this.getLabList({ orgName: formData.searchValue, page: this.page });
    },

    async getLabList(args) {
      const page = args ? args.page ?? this.page : this.page
      const pageSize = args ? args.pageSize ?? this.pageSize : this.pageSize
      const formDataTranslate = this.translateForm({ orgName: this.formData.searchValue,  page, pageSize });
      try {
        const response = await axios.post('/baseinfo/getLabOpenInfo', formDataTranslate, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 200) {
          const { data, total } = response.data;
          const clData = data.map((item) => {
            const picture = this.pic.find(picItem => picItem.alt === item.orgName)
            return {
              ...item,
              picture: picture ? picture.src : '',
            };
          });
        //  this.list = data
          this.list = clData
          this.total = total;
          this.loading = false;
          // 如果当前加载的数据量等于总数据量，则设置 finished 为 true
          if (this.list.length >= this.total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      } catch (error) {
        this.finished = true;
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    componentType() {
      return this.$route.path === "/applySelect"
        ? "ApplyRoomList"
        : "CollegeItemList";
    },
  },
  mounted() {
    this.getLabList();
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  background-color: #f3f3f3;
  height: calc(calc(100vh - 65px));
}
.box .box_header {
  display: flex;
  padding: 10px;
  width: 100%;
}
.rounded-container {
  display: flex;
  flex: 1;
  border-radius: 20px;
  overflow: hidden; /* 确保子元素不会溢出圆角 */
}
.rounded-input {
  flex: 1;
  background-color: #f2f2f4 !important;
}
::v-deep .rounded-input .el-input-group {
  background-color: #f2f2f4 !important;
  border-radius: 20px !important;
}

::v-deep .rounded-input .el-input-group__prepend,
::v-deep .rounded-input .el-input__inner {
  border: none !important;
}
::v-deep .select-with-search .el-input__inner {
  border: 0;
}
.select-with-search {
  width: 100px;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  background-color: #fff !important; /* 确保选择器背景与输入框一致 */
}
.content {
  width: 100%;
  height: calc(calc(100vh - 65px) - 75px);
  overflow-y: auto;
  padding: 0 15px;
}
::v-deep .el-card__body,
.el-main {
  padding: 14px 20px;
}
::v-deep .el-card__header {
  padding: 0;
  position: relative;
}
.bottom_box {
  display: flex;
  width: 100%;
  z-index: 999;
  height: 80px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  padding: 18px 15px;
  line-height: 80px;
}
.bottom_box .yuyue__tomy {
  flex: 1;
  background-color: #329977;
  color: #ffffff;
  border: none;
}
.bottom_box .yuyue__topost {
  flex: 1;
  background-color: #13499b;
  color: #ffffff;
  border: none;
}
</style>
